// extracted by mini-css-extract-plugin
export default {"graphContentWrapper":"StudiesGraphCard_graphContentWrapper__wpnai","graphRowWrapper":"StudiesGraphCard_graphRowWrapper__U6AiL"};